// 横スクロールのカルーセル（受講生の声）
//   <div data-mp-carousel="voices">…カード…</div>
//   <button data-mp-carousel-prev="voices"> / <button data-mp-carousel-next="voices">
// カードは同じ並びを 2 周置いておき、端まで来たら折り返して無限に見せる。
// 5 秒ごとに自動で送る（マウスが乗っている間・フォーカス中・タブが非表示のときは止める。reduced-motion では自動送りなし）。

import { reduceMotion } from './reveal.js';

const AUTOPLAY_MS = 5000;

function scrollLoop(track, direction) {
  const children = track.children;
  if (children.length < 2) return;
  const half = Math.floor(children.length / 2);
  const loopWidth = children[half].offsetLeft - children[0].offsetLeft;
  const step = children[1].offsetLeft - children[0].offsetLeft;
  if (direction > 0 && loopWidth && track.scrollLeft >= loopWidth - 4) track.scrollLeft -= loopWidth;
  if (direction < 0 && loopWidth && track.scrollLeft <= 4) track.scrollLeft += loopWidth;
  track.scrollBy({ left: direction * step, behavior: reduceMotion ? 'auto' : 'smooth' });
}

export function setupCarousels() {
  document.querySelectorAll('[data-mp-carousel]').forEach((track) => {
    const name = track.dataset.mpCarousel;
    const prev = document.querySelector(`[data-mp-carousel-prev="${name}"]`);
    const next = document.querySelector(`[data-mp-carousel-next="${name}"]`);
    prev?.addEventListener('click', () => scrollLoop(track, -1));
    next?.addEventListener('click', () => scrollLoop(track, 1));

    let paused = false;
    const zone = track.closest('section') || track;
    ['pointerenter', 'focusin'].forEach((type) => zone.addEventListener(type, () => { paused = true; }));
    ['pointerleave', 'focusout'].forEach((type) => zone.addEventListener(type, () => { paused = false; }));
    if (!reduceMotion) {
      setInterval(() => {
        if (!paused && !document.hidden) scrollLoop(track, 1);
      }, Number(track.dataset.mpCarouselInterval) || AUTOPLAY_MS);
    }
  });
}
